import PropTypes from "prop-types";
import React from "react";
import ctl from "@netlify/classnames-template-literals";
import tailwindconfig from "../../../tailwind.config";

const {
  theme: {
    extend: { colors },
  },
} = tailwindconfig;

const Text = ({
  value,
  variant: textVariant,
  weight,
  color,
  className,
  children,
  as,
}) => {
  let TextElement = textVariant[0] === "p" ? "p" : textVariant;

  let textColor = "inherit";

  if (color) {
    const [_color, _shade] = color.split("-");

    textColor = colors[_color][_shade ? _shade : "DEFAULT"];
  }

  const textStyle = ctl(`
  ${variants[textVariant]}
  font-light
  group-hover:text-primary-200
  ${className}
  `);

  const dynamicStyle = {
    color: textColor,
    fontWeight: weight,
  };

  if (as) {
    TextElement = as;
  }
  return (
    <TextElement style={dynamicStyle} className={textStyle}>
      {value || children}
    </TextElement>
  );
};

const variants = {
  h1: `
    md:text-[65px]
    text-[37px]
    md:leading-[84.5px]
    leading-[44.4px]
    font-primary
    `,
  h2: `
    md:text-[50px]
    text-[28px]
    md:leading-[65px]
    leading-[39.2px]
    font-primary
    `,

  h3: `
    md:text-[37px]
    text-[21px]
    md:leading-[44.4px]
    leading-[29.4px]
    font-primary
    `,
  h4: `
    md:text-[23px]
    text-[18px]
    md:leading-[34.96px]
    leading-[25.2px]
    font-primary
    `,
  h5: `
    md:text-[18px]
    text-[14px]
    md:leading-[21.6px]
    leading-[19.6px]
    md:normal-case
    uppercase
    font-bold
    `,
  h6: `
    md:text-[14px]
    text-[16px]
    md:leading-[16.8px]
    leading-[19.6px]
    font-semibold 
    `,
  p21: `
    md:text-[21px]
    text-[16px]
    md:leading-[33.6px]
    leading-[28.8px]
   
    `,
  p18: `
    md:text-[18px]
    text-[16px]
    md:leading-[32.4px]
    leading-[28.8px]
    `,
  p16: `
    md:text-[16px]
    text-[14px]
    md:leading-[28.8px]
    leading-[25.2px]
    `,
  p14: `
    md:text-[14px]
    text-[12px]
    md:leading-[25.2px]
    leading-[21.6px]
    `,
  p12: `
    text-[12px]
    leading-[21.6px]
    `,
};
const validElements = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",

  "p12",
  "p14",
  "p16",
  "p18",
  "p21",
];

Text.propTypes = {
  value: PropTypes.string,
  variant: PropTypes.oneOf([...validElements]),
  weight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  className: PropTypes.string,
};

export { Text };
